import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import {
  AvailableProfilesSearchBody,
  AvailableProfilesSearchResponse,
  ClientSuggestionsSearchBody,
  ClientSuggestionsSearchResponse,
  PendingSuggestionsSearchBody,
  PendingSuggestionsSearchResponse,
  ReviewSuggestionsBody,
  ReviewSuggestionsResponse,
  SendSuggestionsBody,
  SendSuggestionsResult,
  SuggestedProfileRow,
} from '../types/suggestion';

export class SuggestionService extends ApiService {
  async searchProfiles(
    targetUserId: string,
    body: AvailableProfilesSearchBody = {}
  ): Promise<AvailableProfilesSearchResponse> {
    return this.post<AvailableProfilesSearchResponse>(
      API_ENDPOINTS.suggestions.search(targetUserId),
      body
    );
  }

  async sendSuggestions(
    targetUserId: string,
    body: SendSuggestionsBody
  ): Promise<SendSuggestionsResult> {
    return this.post<SendSuggestionsResult>(
      API_ENDPOINTS.suggestions.send(targetUserId),
      body
    );
  }

  async searchClientSuggestions(
    targetUserId: string,
    body: ClientSuggestionsSearchBody
  ): Promise<ClientSuggestionsSearchResponse> {
    return this.post<ClientSuggestionsSearchResponse>(
      API_ENDPOINTS.suggestions.clientSearch(targetUserId),
      body
    );
  }

  async searchPending(
    body: PendingSuggestionsSearchBody = {}
  ): Promise<PendingSuggestionsSearchResponse> {
    return this.post<PendingSuggestionsSearchResponse>(
      API_ENDPOINTS.suggestions.pendingSearch,
      body
    );
  }

  async approveSuggestions(
    targetUserId: string,
    body: ReviewSuggestionsBody
  ): Promise<ReviewSuggestionsResponse['data']> {
    return this.post<ReviewSuggestionsResponse['data']>(
      API_ENDPOINTS.suggestions.approve(targetUserId),
      body
    );
  }

  async rejectSuggestions(
    targetUserId: string,
    body: ReviewSuggestionsBody
  ): Promise<ReviewSuggestionsResponse['data']> {
    return this.post<ReviewSuggestionsResponse['data']>(
      API_ENDPOINTS.suggestions.reject(targetUserId),
      body
    );
  }
}

export const suggestionService = new SuggestionService();

export const mapSuggestedProfileRow = (row: SuggestedProfileRow) => {
  const name = [row.firstName, row.lastName].filter(Boolean).join(' ') || 'Unknown';
  const metaParts: string[] = [];
  if (row.age != null) metaParts.push(`${row.age} yrs`);
  if (row.height) metaParts.push(row.height);
  const attributeParts = [row.caste, row.maritalStatus].filter(Boolean);
  const locationParts = [row.city, row.country].filter(Boolean);

  return {
    userId: String(row.userId),
    uniqueId: row.uniqueId,
    name,
    meta: metaParts.join(', '),
    attributes: attributeParts.join(' • '),
    location: locationParts.join(', '),
    career: row.occupation || row.degree || '',
    avatar: row.userImage || undefined,
  };
};

export const formatTargetUserName = (
  firstName: string | null,
  lastName: string | null
): string => [firstName, lastName].filter(Boolean).join(' ') || 'Client';

export const formatSuggestedByName = (
  firstName: string,
  lastName: string
): string => [firstName, lastName].filter(Boolean).join(' ') || 'Staff';
